import { store } from '@/pinia/store'
import { createRouter, createWebHashHistory } from "vue-router";
// types
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/index.vue"),
    meta: {
      title: "登录",
      isNotAuth: true
    },
  },
  {
    path: "/stagingModule/index",
    name: "stagingModule",
    component: () => import("../views/stagingModule/index.vue"),
    meta: {
      title: "工作台",
      isNotAuth: true,
      isShowTabbar: true,
    },
  },
  {
    path: "/orderModule/index",
    name: "orderModule",
    component: () => import("../views/orderModule/index.vue"),
    meta: {
      title: "订单",
      isNotAuth: true,
      isShowTabbar: true,
    },
  },
  {
    path: "/jy/order/feedback",
    name: "orderFeedback",
    component: () => import("../views/jy/order/feedback/index.vue"),
    meta: {
      title: "服务反馈",
      isNotAuth: true,
    },
  },
  {
    path: "/jy/order/feedback/detail",
    name: "orderFeedbackDetail",
    component: () => import("../views/jy/order/feedbackDetail/index.vue"),
    meta: {
      title: "反馈详情",
      isNotAuth: true,
    },
  },
  {
    path: "/jy/order/checklist",
    name: "orderChecklist",
    component: () => import("../views/jy/order/checklist/index.vue"),
    meta: {
      title: "服务检查清单",
      isNotAuth: true,
    },
  },
  {
    path: "/accountModule/index",
    name: "accountModule",
    component: () => import("../views/accountModule/index.vue"),
    meta: {
      title: "账户",
      isNotAuth: true,
      isShowTabbar: true,
    },
  },
  {
    path: "/myModule/index",
    name: "myModule",
    component: () => import("../views/myModule/index.vue"),
    meta: {
      title: "我的",
      isNotAuth: true,
      isShowTabbar: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/index.vue"),
    meta: {
      title: "login",
      isNotAuth: true,
    },
  },
  {
    path: "/debug",
    name: "debug",
    component: () => import("../views/debug/index.vue"),
    meta: {
      title: "debug",
      isNotAuth: true,
    },
  },
  {
    path: "/coupon/index",
    name: "coupon",
    component: () => import("@/views/stagingModule/coupon/index.vue"),
    meta: {
      title: "优惠券管理",
      isNotAuth: true,
    },
  },
  {
    path: "/coupon/add",
    name: "addCoupon",
    component: () => import("@/views/stagingModule/coupon/add.vue"),
    meta: {
      title: "新增优惠券",
      isNotAuth: true,
    },
  },
  {
    path: "/coupon/detail",
    name: "couponDetail",
    component: () => import("@/views/stagingModule/coupon/detail.vue"),
    meta: {
      title: "领取详情",
      isNotAuth: true,
    },
  },
  {
    path: "/technicianVideo/uploadTecVideo/index",
    name: "uploadTecVideo",
    component: () => import("@/views/technicianVideo/uploadTecVideo/index.vue"),
    meta: {
      title: "发布动态",
      isNotAuth: true,
    },
  },
  {
    path: "/withdrawModule/setWithdrawPassword/index",
    name: "setWithdrawPassword",
    component: () =>
      import(
        "@/views/accountModule/withdrawModule/setWithdrawPassword/index.vue"
      ),
    meta: {
      title: "设置提现密码",
      isNotAuth: true,
    },
  },
  {
    path: "/withdrawModule/applyWithdraw/index",
    name: "applyWithdraw",
    component: () =>
      import("@/views/accountModule/withdrawModule/applyWithdraw/index.vue"),
    meta: {
      title: "申请提现",
      isNotAuth: true,
    },
  },
  {
    path: "/withdrawModule/withdrawedList/index",
    name: "withdrawedList",
    component: () =>
      import("@/views/accountModule/withdrawModule/withdrawedList/index.vue"),
    meta: {
      title: "提现记录",
      isNotAuth: true,
    },
  },
  {
    path: "/withdrawModule/myDeposit/index",
    name: "myDeposit",
    component: () =>
      import("@/views/accountModule/withdrawModule/myDeposit/index.vue"),
    meta: {
      title: "我的保证金",
      isNotAuth: true,
    },
  },
  {
    path: "/withdrawModule/serviceFee/index",
    name: "serviceFee",
    component: () =>
      import(
        "@/views/accountModule/withdrawModule/serviceFee/index.vue"
      ),
    meta: {
      title: "服务年费",
      isNotAuth: true,
    },
  },
  {
    path: "/withdrawModule/serviceFee/reduceFeeDetail",
    name: "reduceFeeDetail",
    component: () =>
      import(
        "@/views/accountModule/withdrawModule/serviceFee/reduceFeeDetail.vue"
      ),
    meta: {
      title: "扣费明细",
      isNotAuth: true,
    },
  },
  {
    path: "/technicianVideo/videoTopics/index",
    name: "videoTopics",
    component: () => import("../views/technicianVideo/videoTopics/index.vue"),
    meta: {
      title: "添加话题",
      isNotAuth: true,
    },
  },
  {
    path: "/comment/index",
    name: "comment",
    component: () => import("../views/stagingModule/comment/index.vue"),
    meta: {
      title: "客户评价",
      isNotAuth: true,
    },
  },
  {
    path: "/technicianVideo/videoPlay/index",
    name: "videoPlay",
    component: () => import("../views/technicianVideo/videoPlay/index.vue"),
    meta: {
      title: "视频详情",
      isNotAuth: true,
    },
  },
  {
    path: "/withdrawModule/partnerPravicy/index",
    name: "partnerPravicy",
    component: () =>
      import("../views/accountModule/withdrawModule/partnerPravicy/index.vue"),
    meta: {
      title: "灵活就业合作伙伴协议",
      isNotAuth: false,
    },
  },
  {
    path: "/comment/addReport",
    name: "addReport",
    component: () => import("../views/stagingModule/comment/addReport.vue"),
    meta: {
      title: "举报",
      isNotAuth: true,
    },
  },
  {
    path: "/reportingRecords/index",
    name: "reportingRecords",
    component: () => import("../views/myModule/reportingRecords/index.vue"),
    meta: {
      title: "报备记录",
      isNotAuth: true,
    },
  },
  {
    path: "/reportingRecords/detail",
    name: "reportingDetail",
    component: () => import("../views/myModule/reportingRecords/detail.vue"),
    meta: {
      title: "报备详情",
      isNotAuth: true,
    },
  },
  {
    path: "/reportingRecords/addMoreInfo",
    name: "reportingaAddMoreInfo",
    component: () =>
      import("../views/myModule/reportingRecords/addMoreInfo.vue"),
    meta: {
      title: "报备-补充说明",
      isNotAuth: true,
    },
  },
  {
    path: "/reportingRecords/search",
    name: "searchReportingRecords",
    component: () => import("../views/myModule/reportingRecords/search.vue"),
    meta: {
      title: "搜索报备记录",
      isNotAuth: true,
    },
  },
  {
    path: "/reportingRecords/add",
    name: "addrReporting",
    component: () => import("../views/myModule/reportingRecords/add.vue"),
    meta: {
      title: "创建报备",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/growthRecord/index",
    name: "growthRecord",
    component: () => import("../views/myModule/growthRecord/index.vue"),
    meta: {
      title: "成长记录",
      isNotAuth: true,
    },
  },
  {
    path: "/inspectionTasks/index",
    name: "inspectionTasks",
    component: () => import("../views/myModule/inspectionTasks/index.vue"),
    meta: {
      title: "稽查任务",
      isNotAuth: true,
    },
  },
  {
    path: "/inspectionTasks/detail",
    name: "inspectionTasksDetail",
    component: () => import("../views/myModule/inspectionTasks/detail.vue"),
    meta: {
      title: "稽查任务详情",
      isNotAuth: true,
    },
  },
  {
    path: "/serviceItems/index",
    name: "serviceItems",
    component: () => import("../views/myModule/serviceItems/index.vue"),
    meta: {
      title: "服务项目",
      isNotAuth: true,
    },
  },
  {
    path: "/feedback/index",
    name: "feedback",
    component: () => import("../views/myModule/feedback/index.vue"),
    meta: {
      title: "意见反馈",
      isNotAuth: true,
    },
  },
  {
    path: "/feedback/record",
    name: "feedbackRecord",
    component: () => import("../views/myModule/feedback/record.vue"),
    meta: {
      title: "反馈记录",
      isNotAuth: true,
    },
  },
  {
    path: "/feedback/detail",
    name: "feedbackDetail",
    component: () => import("../views/myModule/feedback/detail.vue"),
    meta: {
      title: "反馈详情",
      isNotAuth: true,
    },
  },
  {
    path: "/feedback/addMore",
    name: "feedbackAddMore",
    component: () => import("../views/myModule/feedback/addMoreInfo.vue"),
    meta: {
      title: "补充说明",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/myMusic/index",
    name: "myMusic",
    component: () => import("../views/myModule/myMusic/index.vue"),
    meta: {
      title: "音乐播放",
      isNotAuth: true,
    },
  },
  // {
  //   path: "/myModule/feedback/index",
  //   name: "feedback",
  //   component: () => import("../views/myModule/feedback/index.vue"),
  //   meta: {
  //     title: "意见问题反馈",
  //     isNotAuth: true,
  //   },
  // },
  // {
  //   path: "/myModule/feedback/feedbackRecords",
  //   name: "feedbackRecords",
  //   component: () => import("../views/myModule/feedback/feedbackRecords.vue"),
  //   meta: {
  //     title: "反馈记录",
  //     isNotAuth: true,
  //   },
  // },
  {
    path: "/myModule/myNotice/index",
    name: "myNotice",
    component: () => import("../views/myModule/myNotice/index.vue"),
    meta: {
      title: "消息中心",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/myNotice/systemNoticeList",
    name: "systemNoticeList",
    component: () => import("../views/myModule/myNotice/systemNoticeList.vue"),
    meta: {
      title: "系统提示",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/myNotice/itemDetail",
    name: "itemDetail",
    component: () => import("../views/myModule/myNotice/itemDetail.vue"),
    meta: {
      title: "系统提示详情",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/settings/index",
    name: "settings",
    component: () => import("../views/myModule/settings/index.vue"),
    meta: {
      title: "设置",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/settings/aboutUs",
    name: "aboutUs",
    component: () => import("../views/myModule/settings/aboutUs.vue"),
    meta: {
      title: "关于我们",
      isNotAuth: true,
    },
  },
  // 抢单（2026-10-14）：抢单大厅 / 需求详情
  {
    path: "/demandModule/hall",
    name: "demandHall",
    component: () => import("../views/demandModule/hall.vue"),
    meta: {
      title: "抢单大厅",
      isNotAuth: true,
    },
  },
  {
    path: "/demandModule/detail",
    name: "demandDetail",
    component: () => import("../views/demandModule/detail.vue"),
    meta: {
      title: "需求详情",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/settings/pickupOrderSetting",
    name: "pickupOrderSetting",
    component: () =>
      import("../views/myModule/settings/pickupOrderSetting.vue"),
    meta: {
      title: "接单设置",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/pageDeco/index",
    name: "pageDeco",
    component: () => import("../views/myModule/pageDeco/index.vue"),
    meta: {
      title: "页面装修",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/settings/accountAndSafe",
    name: "accountAndSafe",
    component: () => import("../views/myModule/settings/accountAndSafe.vue"),
    meta: {
      title: "账号与安全",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/settings/operationStep",
    name: "operationStep",
    component: () => import("../views/myModule/settings/operationStep.vue"),
    meta: {
      title: "操作流程",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/settings/freeCarFee",
    name: "freeCarFee",
    component: () => import("../views/myModule/settings/freeCarFee.vue"),
    meta: {
      title: "免车费设置",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/settings/testCookie",
    name: "testCookie",
    component: () => import("../views/myModule/settings/testCookie.vue"),
    meta: {
      title: "测试写入cookie",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/settings/testCookie1",
    name: "testCookie1",
    component: () => import("../views/myModule/settings/testCookie1.vue"),
    meta: {
      title: "测试写入cookie1",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/chooseCity/index",
    name: "chooseCity",
    component: () => import("../views/myModule/chooseCity/index.vue"),
    meta: {
      title: "选择城市",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/joinApply/index",
    name: "joinApply",
    component: () => import("../views/myModule/joinApply/index.vue"),
    meta: {
      title: "个人信息认证",
      isNotAuth: true,
    },
  },
  {
    path: "/mallModule/mallList",
    name: "mallList",
    component: () => import("../views/mallModule/mallList.vue"),
    meta: {
      title: "购物商场",
      isNotAuth: true,
    },
  },
  {
    path: "/mallModule/confirmOrder",
    name: "confirmOrder",
    component: () => import("../views/mallModule/confirmOrder.vue"),
    meta: {
      title: "确认订单",
      isNotAuth: true,
    },
  },
  {
    path: "/mallModule/addressManage",
    name: "addressManage",
    component: () => import("../views/mallModule/addressManage.vue"),
    meta: {
      title: "修改地址",
      isNotAuth: true,
    },
  },
  {
    path: "/mallModule/orderDetail",
    name: "orderDetail",
    component: () => import("../views/mallModule/orderDetail.vue"),
    meta: {
      title: "订单详情",
      isNotAuth: true,
    },
  },
  {
    path: "/mallModule/payState",
    name: "payState",
    component: () => import("../views/mallModule/payState.vue"),
    meta: {
      title: "支付结果",
      isNotAuth: true,
    },
  },
  {
    path: "/mallModule/orderList",
    name: "mallOrderList",
    component: () => import("../views/mallModule/orderList.vue"),
    meta: {
      title: "商城订单",
      isNotAuth: true,
    },
  },
  {
    path: "/withdrawModule/myDeposit/chargeDeposit",
    name: "chargeDeposit",
    component: () => import("../views/accountModule/withdrawModule/myDeposit/chargeDeposit.vue"),
    meta: {
      title: "保证金充值",
      isNotAuth: true,
    },
  },
  {
    path: "/accountModule/billDetails",
    name: "billDetails",
    component: () => import("../views/accountModule/billDetails/index.vue"),
    meta: {
      title: "账单明细",
      isNotAuth: true,
    },
  },
  {
    path: "/withdrawModule/myDeposit/chargeSuccess",
    name: "chargeSuccess",
    component: () => import("../views/accountModule/withdrawModule/myDeposit/chargeSuccess.vue"),
    meta: {
      title: "充值成功",
      isNotAuth: true,
    },
  },
  {
    path: "/accountModule/bankCards",
    name: "bankCards",
    component: () => import("../views/accountModule/bankCards/index.vue"),
    meta: {
      title: "我的银行卡",
      isNotAuth: true,
    },
  },
  {
    path: "/withdrawModule/applyWithdraw/forgetPassword",
    name: "forgetPassword",
    component: () => import("../views/accountModule/withdrawModule/applyWithdraw/forgetPassword.vue"),
    meta: {
      title: "忘记密码",
      isNotAuth: true,
    },
  },
  {
    path: "/accountModule/bankCards/add",
    name: "addBankCards",
    component: () => import("../views/accountModule/bankCards/add.vue"),
    meta: {
      title: "添加银行卡",
      isNotAuth: true,
    },
  },
  {
    path: "/withdrawModule/applyWithdraw/withdrawResult",
    name: "withdrawResult",
    component: () => import("../views/accountModule/withdrawModule/applyWithdraw/withdrawResult.vue"),
    meta: {
      title: "申请提现成功",
      isNotAuth: true,
    }
  },
  {
    path: "/partnerModule/partnerApply/index",
    name: "partnerApply",
    component: () => import("../views/partnerModule/partnerApply/index.vue"),
    meta: {
      title: "考拉商家入驻",
      isNotAuth: true,
    },
  },
  {
    path: "/partnerModule/submitResult",
    name: "submitResult",
    component: () => import("../views/partnerModule/submitResult.vue"),
    meta: {
      title: "",
      isNotAuth: true,
    },
  },
  {
    path: "/partnerModule/partnerBankCard/index",
    name: "partnerBankCard",
    component: () => import("../views/partnerModule/partnerBankCard/index.vue"),
    meta: {
      title: "开通汇付账号",
      isNotAuth: true,
    },
  },
  {
    path: "/partnerModule/partnerSigning/index",
    name: "partnerSigning",
    component: () => import("../views/partnerModule/partnerSigning/index.vue"),
    meta: {
      title: "签约流程",
      isNotAuth: true,
    },
  },
  {
    path: "/partnerModule/partnerBalancePay/index",
    name: "partnerBalancePay",
    component: () => import("../views/partnerModule/partnerBalancePay/index.vue"),
    meta: {
      title: "开通余额支付",
      isNotAuth: true,
    },
  },
  {
    path: "/partnerModule/partnerSigning/signStep",
    name: "signStep",
    component: () => import("../views/partnerModule/partnerSigning/signStep.vue"),
    meta: {
      title: "签约流程",
      isNotAuth: true,
    },
  },
  {
    path: "/pages/bridge/index",
    name: "bridge",
    component: () => import("../views/pages/bridge/index.vue"),
    meta: {
      title: "测试App桥",
      isNotAuth: true,
    },
  },
  {
    path: "/pages/wechat/index",
    name: "wechat",
    component: () => import("../views/pages/wechat/index.vue"),
    meta: {
      title: "联系负责人",
      isNotAuth: true,
    },
  },
  {
    path: "/pages/busi/wechat/index",
    name: "busiWechat",
    component: () => import("../views/pages/busi/wechat/index.vue"),
    meta: {
      title: "联系商家负责人",
      isNotAuth: true,
    },
  },
  {
    path: "/pages/shareNowLocation/index",
    name: "shareNowLocation",
    component: () => import("../views/pages/shareNowLocation/index.vue"),
    meta: {
      title: "共享实时位置",
      isNotAuth: true,
    },
  },
  {
    path: "/pages/inspectionTask/applyAppeal",
    name: "applyAppeal",
    component: () => import("../views/pages/inspectionTask/applyAppeal/index.vue"),
    meta: {
      title: "稽查申诉",
    },
  },
  {
    path: "/pages/inspectionTask/appealDetail",
    name: "appealDetail",
    component: () => import("../views/pages/inspectionTask/appealDetail/index.vue"),
    meta: {
      title: "申诉详情",
    },
  },
  {
    path: "/pages/videoBanner/index",
    name: "videoBanner",
    component: () => import("../views/pages/videoBanner/index.vue"),
    meta: {
      title: "短视频拍摄详解",
      isNotAuth: true,
    },
  },
  {
    path: "/pages/videoSolicitation/index",
    name: "videoSolicitation",
    component: () => import("../views/pages/videoSolicitation/index.vue"),
    meta: {
      title: "短视频征集",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/settings/blockList",
    name: "blockList",
    component: () => import("../views/myModule/settings/blockList.vue"),
    meta: {
      title: "黑名单",
      isNotAuth: true,
    },
  },
  {
    path: "/pages/shareNowLocation/index",
    name: "shareNowLocation",
    component: () => import("../views/pages/shareNowLocation/index.vue"),
    meta: {
      title: "实时定位",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/settings/personalInfo",
    name: "personalInfo",
    component: () => import("../views/myModule/settings/personalInfo.vue"),
    meta: {
      title: "个人信息展示",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/settings/incomingCall",
    name: "incomingCall",
    component: () => import("../views/myModule/settings/incomingCall.vue"),
    meta: {
      title: "来单提示音",
      isNotAuth: true,
    },
  },
  {
    path: "/myModule/myLevel/index",
    name: "myLevel",
    component: () => import("../views/myModule/myLevel/index.vue"),
    meta: {
      title: "我的等级",
      isNotAuth: true,
    },
  },
  {
    path: "/stagingModule/comment/chatRecords",
    name: "chatRecords",
    component: () => import("../views/stagingModule/comment/chatRecords.vue"),
    meta: {
      title: "沟通记录",
      isNotAuth: true,
    },
  },
  {
    path: "/stagingModule/comment/quickReply",
    name: "quickReply",
    component: () => import("../views/stagingModule/comment/quickReply.vue"),
    meta: {
      title: "快捷回复",
      isNotAuth: true,
    },
  },
  {
    path: "/stagingModule/comment/reportRecords",
    name: "reportRecords",
    component: () => import("../views/stagingModule/comment/reportRecords.vue"),
    meta: {
      title: "举报记录",
      isNotAuth: true,
    },
  },
  {
    path: "/stagingModule/comment/reportDetail",
    name: "reportDetail",
    component: () => import("../views/stagingModule/comment/reportDetail.vue"),
    meta: {
      title: "举报详情",
      isNotAuth: true,
    },
  },
  {
    path: "/stagingModule/comment/unUseComments",
    name: "unUseComments",
    component: () => import("../views/stagingModule/comment/unUseComments.vue"),
    meta: {
      title: "被折叠评价",
      isNotAuth: true,
    },
  },
  {
    path: '/pages/techReport/index',
    name: 'techReport',
    component: () => import('../views/pages/techReport/index.vue'),
    meta: {
      title: '数据统计',
      isNotAuth: true
    },
  },
  {
    path: '/pages/techReport/feelToTa',
    name: 'feelToTa',
    component: () => import('../views/pages/techReport/feelToTa.vue'),
    meta: {
      title: '对ta的印象',
      isNotAuth: true
    },
  },
  {
    path: '/pages/techReport/creditScore',
    name: 'creditScore',
    component: () => import('../views/pages/techReport/creditScore.vue'),
    meta: {
      title: '我的信用分',
      isNotAuth: true
    },
  },
  {
    path: '/pages/invite/friend',
    name: 'inviteFriend',
    component: () => import('../views/pages/inviteNew/friend/index.vue'),
    meta: {
      title: '邀请好友',
      isNotAuth: true,
    },
  },
  {
    path: '/pages/invite/rule',
    name: 'inviteRule',
    component: () => import('../views/pages/inviteNew/rule/index.vue'),
    meta: {
      title: '活动规则',
      isNotAuth: true,
    },
  },
  {
    path: '/pages/invite/detail',
    name: 'inviteDetail',
    component: () => import('../views/pages/inviteNew/detail/index.vue'),
    meta: {
      title: '邀请明细',
      keepAlive: true,
      isNotAuth: true,
    },
  },
  {
    path: '/pages/invite/tech/rule',
    name: 'inviteTechRule',
    component: () => import('../views/pages/invite/rule.vue'),
    meta: {
      title: '赚钱攻略',
      isNotAuth: true,
    },
  },
  {
    path: '/pages/invite/tech/historyRule',
    name: 'inviteTechHistoryRule',
    component: () => import('../views/pages/invite/historyRule.vue'),
    meta: {
      title: '历史规则',
      isNotAuth: true,
    },
  },
  {
    path: '/pages/invite/reward',
    name: 'inviteReward',
    component: () => import('../views/pages/inviteNew/reward/index.vue'),
    meta: {
      title: '奖励明细',
      isNotAuth: true,
    },
  },
  {
    path: '/pages/invite/posterNew',
    name: 'invitePosterNew',
    component: () => import('../views/pages/inviteNew/poster/index.vue'),
    meta: {
      title: '邀请海报',
      isNotAuth: true,
    },
  },
  {
    path: '/pages/invite/friendList',
    name: 'inviteFriendList',
    component: () => import('../views/pages/invite/friendList.vue'),
    meta: {
      title: '邀请好友列表',
      index: 916,
      isNotAuth: true
    },
  },
  {
    path: '/pages/invite/technician',
    name: 'inviteTechnician',
    component: () => import('../views/pages/invite/technician.vue'),
    meta: {
      title: '邀请技师',
      isNotAuth: true
    },
  },
  {
    path: '/pages/invite/technicianList',
    name: 'inviteTechnicianList',
    component: () => import('../views/pages/invite/technicianList.vue'),
    meta: {
      title: '邀请技师列表',
      isNotAuth: true,
    },
  },
  {
    path: '/pages/invite/poster',
    name: 'poster',
    component: () => import('../views/pages/invite/poster.vue'),
    meta: {
      title: '邀请海报',
      isNotAuth: true
    },
  },
  {
    path: '/pages/invite/partner',
    name: 'partnerInviteFriends',
    component: () => import('../views/pages/invite/partner.vue'),
    meta: {
      title: '邀请技师',
      keepAlive: true,
      isNotAuth: true
    },
  },
  {
    path: '/pages/invite/techRegister',
    name: 'techRegister',
    component: () => import('../views/pages/invite/techRegister.vue'),
    meta: {
      title: '考拉',
      isNotAuth: true
    },
  },
  {
    path: '/pages/invite/inviteCode',
    name: 'inviteCode',
    component: () => import('../views/pages/invite/inviteCode.vue'),
    meta: {
      title: '邀请二维码',
      isNotAuth: true
    },
  },
  {
    path: '/pages/businessSchool/index',
    name: 'businessSchool',
    component: () => import('../views/pages/businessSchool/index.vue'),
    meta: {
      title: '商学院',
      isNotAuth: true
    },
  },
  {
    path: '/pages/businessSchool/courseDetail',
    name: 'courseDetail',
    component: () => import('../views/pages/businessSchool/courseDetail.vue'),
    meta: {
      title: '课程详情',
      isNotAuth: true
    },
  },
  {
    path: '/pages/businessSchool/allCourse',
    name: 'allCourse',
    component: () => import('../views/pages/businessSchool/allCourse.vue'),
    meta: {
      title: '全部课程',
      isNotAuth: true,
      keepAlive: true
    }
  },
  {
    path: '/pages/businessSchool/courseClassify',
    name: 'courseClassify',
    component: () => import('../views/pages/businessSchool/courseClassify.vue'),
    meta: {
      title: '课程分类',
      isNotAuth: true
    },
  },
  {
    path: '/pages/businessSchool/myCollect',
    name: 'myCollect',
    component: () => import('../views/pages/businessSchool/myCollect.vue'),
    meta: {
      title: '收藏课程',
      isNotAuth: true
    }
  },
  {
    path: '/pages/businessSchool/myCourse',
    name: 'myCourse',
    component: () => import('../views/pages/businessSchool/myCourse.vue'),
    meta: {
      title: '我的课程',
      isNotAuth: true
    },
  },
  {
    path: '/pages/businessSchool/search',
    name: 'searchCourse',
    component: () => import('../views/pages/businessSchool/search.vue'),
    meta: {
      title: '搜索课程',
      isNotAuth: true
    },
  },
  {
    path: '/pages/businessSchool/viewRecord',
    name: 'viewRecord',
    component: () => import('../views/pages/businessSchool/viewRecord.vue'),
    meta: {
      title: '课程浏览记录',
      isNotAuth: true
    },
  },
  {
    path: '/pages/newbieTask/index',
    name: 'newbieTask',
    component: () => import('../views/pages/newbieTask/index.vue'),
    meta: {
      // title: '任务中心',
      title: '五城活动报名登记',
      isNotAuth: true
    },
  },
  {
    path: '/pages/bindWechat/index',
    name: 'bindWechat',
    component: () => import('../views/pages/bindWechat/index.vue'),
    meta: {
      title: '绑定微信',
      isNotAuth: true
    },
  },
  {
    path: '/pages/bindWechat/tipsForBind',
    name: 'tipsForBind',
    component: () => import('../views/pages/bindWechat/tipsForBind.vue'),
    meta: {
      title: '绑定提示',
      isNotAuth: true
    },
  },
  {
    path: '/pages/bindWechat/bindSuccess',
    name: 'bindSuccess',
    component: () => import('../views/pages/bindWechat/bindSuccess.vue'),
    meta: {
      title: '绑定成功',
      isNotAuth: true
    },
  },
  {
    path: '/pages/dataCenter/index',
    name: 'dataCenter',
    component: () => import('../views/pages/dataCenter/index.vue'),
    meta: {
      title: '数据中心',
      isNotAuth: true
    },
  },
  {
    path: '/pages/dataCenter/rule',
    name: 'dataCenterRule',
    component: () => import('../views/pages/dataCenter/rule.vue'),
    meta: {
      title: '规则说明',
      isNotAuth: true
    },
  },
  {
    path: '/pages/helpDoc/index',
    name: 'helpDoc',
    component: () => import('../views/pages/helpDoc/index.vue'),
    meta: {
      title: '常见问题',
      isNotAuth: true
    },
  },
  {
    path: '/pages/helpDoc/detail',
    name: 'helpDocDetail',
    component: () => import('../views/pages/helpDoc/detail.vue'),
    meta: {
      title: '详情',
      isNotAuth: true
    },
  },
  {
    path: '/pages/techOperate/index',
    name: 'techOperate',
    component: () => import('../views/pages/techOperate/index.vue'),
    meta: {
      title: '理疗师账户基础运营小技巧',
      isNotAuth: true
    },
  },
  {
    path: '/pages/redEnvelope/index',
    name: 'redEnvelope',
    component: () => import('../views/pages/redEnvelope/index.vue'),
    meta: {
      title: '红包雨',
      isNotAuth: true
    },
  },
  {
    path: '/pages/sideAgreement/index',
    name: 'sideAgreement',
    component: () => import('../views/pages/sideAgreement/index.vue'),
    meta: {
      title: '考拉技师补充协议',
      isNotAuth: true
    },
  },
  {
    path: '/pages/redEnvelope/indexNotice',
    name: 'indexNotice',
    component: () => import('../views/pages/redEnvelope/indexNotice.vue'),
    meta: {
      title: '红包雨预告页',
      isNotAuth: true
    },
  },
  {
    path: '/myModule/settings/modifyMobile/index',
    name: 'modifyMobile',
    component: () => import('../views/myModule/settings/modifyMobile/index.vue'),
    meta: {
      title: '修改手机号',
      isNotAuth: true
    },
  },
  {
    path: '/myModule/settings/modifyMobile/successModify',
    name: 'successModify',
    component: () => import('../views/myModule/settings/modifyMobile/successModify.vue'),
    meta: {
      title: '修改手机号',
      isNotAuth: true
    },
  },
  {
    path: '/stagingModule/message/ysf/index',
    name: 'ysfMessage',
    component: () => import('../views/stagingModule/message/ysf/index.vue'),
    meta: {
      title: '在线客服',
      isNotAuth: true
    },
  },
  // {
  //   path: '/stagingModule/taskCenter/index',
  //   name: 'taskCenter',
  //   component: () => import('../views/stagingModule/taskCenter/index.vue'),
  //   meta: {
  //     title: '任务中心',
  //     isNotAuth: true
  //   },
  // },
  {
    path: '/newbieTask/taskCenter/pastTask',
    name: 'pastTask',
    component: () => import('../views/pages/newbieTask/pastTask.vue'),
    meta: {
      title: '往期任务',
      isNotAuth: true
    },
  },
  {
    path: '/newbieTask/taskCenter/myJoin',
    name: 'myJoin',
    component: () => import('../views/pages/newbieTask/myJoin.vue'),
    meta: {
      title: '我的参与',
      isNotAuth: true
    },
  },
  {
    path: '/newbieTask/taskCenter/taskDetail',
    name: 'taskDetail',
    component: () => import('../views/pages/newbieTask/taskDetail/index.vue'),
    meta: {
      title: '任务详情',
      isNotAuth: true
    },
  },
  {
    path: '/myModule/settings/serveDistance',
    name: 'serveDistance',
    component: () => import('../views/myModule/settings/serveDistance.vue'),
    meta: {
      title: '服务距离设置',
      isNotAuth: true
    },
  },
  {
    path: '/pages/techExposurePackage/index',
    name: 'techExposurePackageIndex',
    component: () => import('../views/pages/techExposurePackage/index/index.vue'),
    meta: {
      title: '我要推广',
      keepAlive: true,
      isNotAuth: true
    },
  },
  {
    path: '/pages/techExposurePackage/detail',
    name: 'techExposurePackageDetail',
    component: () => import('@/views/pages/techExposurePackage/detail/index.vue'),
    meta: {
      title: '订单详情',
      isNotAuth: true
    },
  },
  {
    path: '/pages/techExposurePackage/record',
    name: 'techExposurePackageRecord',
    component: () => import('../views/pages/techExposurePackage/record/index.vue'),
    meta: {
      title: '订单记录',
      keepAlive: true,
      isNotAuth: true
    },
  },
  {
    path: '/pages/techExposurePackage/effect',
    name: 'techExposurePackageEffect',
    component: () => import('../views/pages/techExposurePackage/effect/index.vue'),
    meta: {
      title: '有什么效果',
      isNotAuth: true
    },
  },
  {
    path: '/pages/techExposurePackage/notice',
    name: 'techExposurePackageNotice',
    component: () => import('../views/pages/techExposurePackage/notice/index.vue'),
    meta: {
      title: '推广注意事项',
      isNotAuth: true
    },
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  const storeData = store()
  console.log(from)
  console.log(to)
  if ((to?.meta?.title as string)?.length) {
    document.title = to.meta.title.toString()
  }
  const appDataStore = store()
  keepAliveInit(to, from, appDataStore)
  if (from.path !== '/' && !storeData.isShowNewSource && (!localStorage.getItem('techExpiresAt') || (localStorage.getItem('techExpiresAt') && parseInt(localStorage.getItem('techExpiresAt')) * 1000 - new Date().getTime() <= 60000)) && storeData.appData.userId) {
    console.log('router调用刷新接口')
    let tsApi = import('@/tsApi/service.ts')
    console.log(tsApi)
    tsApi.then((res) => {
      console.log(res)
      try {
        if (to.path.indexOf('partnerModule') > -1) {
          res.resetPartnerExpiresAt()
        } else {
          res.resetTechExpiresAt()
        }
      } catch (e) { }
    })
  }
  next()
})

//页面缓存初始化方法
const keepAliveInit = async (to, from, appDataStore) => {
  if (to.name == 'inviteDetail' && from.name != 'inviteReward') {
    pushKeepAlive('inviteDetail', appDataStore)
  }
  if (from.name == 'inviteDetail' && to.name != 'inviteReward') {
    deleteKeepAlive('inviteDetail', appDataStore)
  }

  if (to.name == 'techExposurePackageIndex' && !['techExposurePackageDetail', 'techExposurePackageRecord', 'techExposurePackageEffect', 'techExposurePackageNotice'].includes(from.name)) {
    pushKeepAlive('techExposurePackageIndex', appDataStore)
  }
  if (from.name == 'techExposurePackageIndex' && !['techExposurePackageDetail', 'techExposurePackageRecord', 'techExposurePackageEffect', 'techExposurePackageNotice'].includes(to.name)) {
    deleteKeepAlive('techExposurePackageIndex', appDataStore)
  }
  if (to.name == 'techExposurePackageRecord' && !['techExposurePackageDetail'].includes(from.name)) {
    pushKeepAlive('techExposurePackageRecord', appDataStore)
  }
  if (from.name == 'techExposurePackageRecord' && !['techExposurePackageDetail'].includes(to.name)) {
    deleteKeepAlive('techExposurePackageRecord', appDataStore)
  }
}
//增加缓存页面
const pushKeepAlive = (name, appDataStore) => {
  const index = appDataStore.keepAliveInclude.findIndex((item) => item == name)
  if (index < 0) {
    appDataStore.keepAliveInclude.push(name)
  }
}
//删除缓存页面
const deleteKeepAlive = (name, appDataStore) => {
  const confirmOrderIndex = appDataStore.keepAliveInclude.findIndex((item) => item == name)
  if (confirmOrderIndex > -1) {
    appDataStore.keepAliveInclude.splice(confirmOrderIndex, 1)
  }
}

export default router;
